import { useEffect, useRef } from 'react';
import { useUser } from '@/contexts/UserContext';
import HomePage from '../HomePage/HomePage';
import MyHomePage from '../MyHomePage/MyHomePage';
import { HomepageContextProvider } from '@/contexts/HomepageContext';
import { MyHomepageContextProvider } from '@/contexts/MyHomePageContext';
import { openPersonasEditor } from './PersonasEditor';
import { openSupportOptionEditor } from './SupportOptionEditor';

export const SUPPORT_PREF_SKIP_KEY = 'lastOboSupportPrefSkipDtm';

export default function HomePageConfigEditor({ ...props }) {
    const { subscription, user, isCsrObo } = useUser();
    const oboSupportPrefSkippedRef = useRef<string>(getOboSupportPrefSkippedFromSession()); // should only be 'true' or 'false'

    const userIsSetupAdmin = user?.role === 'admin' && user?.features?.hidden;
    const isFreeUser = Boolean(subscription?.metadata?.isFree);
    const includeSkip = isFreeUser && isCsrObo;

    const oboFreeUserSupportPrefModalSkipped = (() => {
        return oboSupportPrefSkippedRef.current === 'true';
    })();

    const canShowOboFreeUserSupportPrefModal = !isCsrObo || (includeSkip && !oboFreeUserSupportPrefModalSkipped);

    function getOboSupportPrefSkippedFromSession() {
        try {
            return sessionStorage.getItem(SUPPORT_PREF_SKIP_KEY) ?? 'false';
        } catch {
            return 'false';
        }
    };

    useEffect(() => {
        if (user) {
            const { showPersonasPopup = false } = user.metadata;

            (async () => {
                if (showPersonasPopup && user?.tcsAccepted && !isCsrObo) {
                    // Opens only under specific conditions
                    try {
                        // @ts-ignore
                        await openPersonasEditor({ includeSkip: true, includeSubmit: true });
                    } catch (error) {
                        throw error;
                    }
                }
            })();
        }
    }, [user?.tcsAccepted]);

    useEffect(() => {
        if (user) {
            const { supportCode } = user.metadata;

            (async () => {
                const showSupportPrefModal = supportCode === undefined && isFreeUser && !userIsSetupAdmin && canShowOboFreeUserSupportPrefModal;

                if (showSupportPrefModal) {
                    try {
                        // @ts-expect-error - we have issues with types in modals.  It throws a false negative 
                        await openSupportOptionEditor({ includeSkip });
                    } catch (error) {
                        throw error;
                    }
                }
            })();
        }
    }, [user?.metadata]);

    return (
        <>
            {isFreeUser ? (
                <MyHomepageContextProvider>
                    <MyHomePage className={undefined} />
                </MyHomepageContextProvider>
            ) : (
                <HomepageContextProvider>
                    <HomePage className={undefined} />
                </HomepageContextProvider>
            )}
        </>
    );
}
